import sndRoutes from './sub-modules/snd/routes.js'


export default [...sndRoutes]
